import React, { Component } from 'react';
import { Load, LabelWithArrow } from './common/basic';
import DatePicker from './common/datepicker';
import { TableHeaderColumn } from 'react-bootstrap-table';
import DataGrid from './common/dataGrid';
import UserSearch from './common/userSearch';
import DropDown from './common/dropDown';
import enums from '../config/enums';
import { CheckBox, ApplyAndReset } from './common/forms';
import moment from 'moment';
import '../public/less/forms.less';
import {
    Button
} from 'react-bootstrap';
var Confirm = require('react-confirm-bootstrap');
import axios from 'axios';
import CSVExport from './common/CSVExport';
import dateHelper from '../helpers/date.js';
// Search Panel
class UsersSearch extends Component {

    constructor(props) {
        super(props);

        this.userTypeChanged = this
            .userTypeChanged
            .bind(this);

        this.state = getDefaultParams();
    };

    getSearchParams() {
        var params = this.state;

        params.doctor = this
            ._doctorSearch
            .getUser();

        this.setSearchParams(params);

        return params;
    }

    setSearchParams(params) {
        this.setState(params);
    }

    changeFrom(date) {
        this.setState({ fromDate: date });
    }

    changeTo(date) {
        this.setState({ toDate: date });
    }

    userTypeChanged(id, isChecked) {
        var userTypeIDs = this.state.userTypeIDs;
        if (!isChecked) {
            var index = userTypeIDs.indexOf(id);
            if (index > -1) {
                userTypeIDs.splice(index, 1);
            }
        } else {
            userTypeIDs.push(id);
        }

        this.setState({ userTypeIDs: userTypeIDs })
    }

    redirectToRegister() {
        window.location.href = "/register";
    }

    render() {
        return (
            <div>
                <div className='SearchContainer float-left' style={SearchContainerStyle}>
                    <div>
                        <div>
                            <div className='float-left right-border '>
                                <DatePicker
                                    className='display-table'
                                    Label='From date'
                                    type="start"
                                    startDate={this.state.fromDate}
                                    endDate={this.state.toDate}
                                    onChange={this
                                        .changeFrom
                                        .bind(this)} />
                                <DatePicker
                                    className='display-table'
                                    Label='To date'
                                    type="end"
                                    startDate={this.state.fromDate}
                                    endDate={this.state.toDate}
                                    ContainerType='input'
                                    onChange={this
                                        .changeTo
                                        .bind(this)} />
                            </div>
                            <div className='float-left right-border '>
                                <h5>Doctor name</h5>
                                <UserSearch
                                    Value={this.state.doctor}
                                    ref={(doctorSearch) => {
                                        this._doctorSearch = doctorSearch;
                                    }} />
                            </div>
                            <div className='float-left' style={userTypeStyle}>
                                <DropDown
                                    id="userType"
                                    Label="User type"
                                    Data={userTypes}
                                    onChange={this.userTypeChanged} />
                            </div>
                            <div className='float-left'>
                                <ApplyAndReset
                                    Search={this
                                        .props
                                        .Search
                                        .bind(this)}
                                    ApplyReset={this
                                        .props
                                        .ApplyReset
                                        .bind(this)} />
                            </div>
                            <div className='float-left'>
                                <CSVExport 
                                ajaxUrl='/data/getUsers' 
                                parameters={this.state} 
                                dbKeys={['Doctor', 'LastActive', 'UserType']} 
                                csvKeys={['Doctor name', 'Last entry', 'User type']}
                                fileName={'Users_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv'}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='float-right' style={addNewUserStyle}>
                    <Button type="button" className='purple btn btn-default' onClick={this.redirectToRegister}>
                        + ADD USER
                    </Button>
                </div>
            </div>
        )
    }
}

var userTypes = [
    {
        id: enums.USER_TYPE.SUPER,
        name: 'Super',
        isChecked: true
    }, {
        id: enums.USER_TYPE.DOCTOR,
        name: 'Doctor',
        isChecked: true
    }, {
        id: enums.USER_TYPE.IT,
        name: 'IT'
    }
];

const addNewUserStyle = {
    paddingTop: '70px'
};

const userTypeStyle = {
    width: '150px'
};

const SearchContainerStyle = {
    width: '910px',
    height: '120px'
};

module.exports = class Users extends Component {
    constructor(props) {
        super(props);

        this.state = getDefaultParams();

        this.handleDelete = this.handleDelete.bind(this);
        this.editDeleteFormatter = this.editDeleteFormatter.bind(this);
    }

    Search() {
        var params = this
            ._usersSearch
            .getSearchParams();

        this.setState({ params });
        this
            ._dataGrid
            .setNewParameters(this.GetParams(params));
    }

    ApplyReset() {
        this.setState(getDefaultParams());

        this
            ._dataGrid
            .setNewParameters(getDefaultParams());

        this
            ._usersSearch
            .setSearchParams(getDefaultParams());
    }

    GetParams(params) {
        var params = {
            fromDate: params
                .fromDate
                .toLocaleDateString(),
            toDate: params
                .toDate
                .toLocaleDateString(),
            doctorText: params.doctor.text,
            doctorID: params.doctor.ID,
            userTypeIDs: params.userTypeIDs
        }
        return params;
    }

    editDeleteFormatter(cell, row, enumObject, index) {
        var editLink = "/edit/" + row.ID;
        var confirmText = "Confirm Delete " + row.Doctor;
        var body = " Are you sure you want to delete this?";

        return (<div>
            <a href={editLink} className='editUrl button'>Edit</a> | <Confirm
                onConfirm={() => { this.handleDelete(row, index) }}
                body={body}
                confirmText={confirmText}
                title={confirmText}>
                <span className='deleteUrl button' onClick={this.handleDelete}>Delete</span>
            </Confirm>
        </div>
        )
    }

    handleDelete(row, index) {
        var url = '/data/deactivateUser/' + row.ID;
        this._dataGrid.showLoading();
        var _this = this;
        axios
            .post(url)
            .then(function (data) {
                var gridData = _this._dataGrid.getData();
                gridData.splice(index, 1);
                _this._dataGrid.setData(gridData);

                _this._dataGrid.hideLoading();
                console.log(data);
            })
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });
    }


    render() {
        var params = this.GetParams(this.state);

        return (
            <div className='container'>
                <UsersSearch
                    ref={(usersSearch) => {
                        this._usersSearch = usersSearch;
                    }}
                    ApplyReset={this
                        .ApplyReset
                        .bind(this)}
                    Search={this
                        .Search
                        .bind(this)} />
                <div>
                    <DataGrid
                        ref={(dataGrid) => {
                            this._dataGrid = dataGrid;
                        }}
                        ajaxUrl='/data/getUsers'
                        ID='UsersGrid'
                        parameters={params}
                        OnClick={this.rowClick}
                        ExpandableRow={this.isExpandable}
                        trClassFormat={this.trClassFormat}
                        ExpandComponent={this.expandComponent}>
                        <TableHeaderColumn isKey hidden dataField='ID' />
                        <TableHeaderColumn dataField='Doctor' dataSort>Doctor name</TableHeaderColumn>
                        <TableHeaderColumn dataField='LastActive' dataFormat={dateFormatter} dataSort>Last entry</TableHeaderColumn>
                        <TableHeaderColumn dataField='UserType' dataSort>User type</TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataFormat={moreInfoFormatter}></TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataFormat={this.editDeleteFormatter}></TableHeaderColumn>
                    </DataGrid>
                </div>
            </div>
        )
    }
};

var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();

var selectedUserTypes = [enums.USER_TYPE.SUPER, enums.USER_TYPE.DOCTOR];

function getDefaultParams() {
    const DefaultParams = {
        fromDate: new Date(y, m, 1),
        toDate: new Date(y, m + 1, 0),
        doctor: {
            ID: 0,
            text: ''
        }
    }

    DefaultParams.userTypeIDs = selectedUserTypes.concat();

    return DefaultParams;
}

function dateFormatter(cell, row) {
    return `${moment(new Date(cell)).format("DD.MM.YYYY")}`;
}

/* More Details */
function moreInfoFormatter(cell, row, enumObject, index) {
    var url = '/doctor/' + row.ID;
    return <a href={url}><Button className='hoverpurple btn btn-default'>More Info</Button></a>
}

/* More Details */




// WEBPACK FOOTER //
// ./modules/users.jsx